<template>
    <div class="user-retreat-chart"></div>
</template>

<script>
export default {
    data: function () {
        return {}
    },
    props: [
        'chartX',
        'chartY'
    ],
    mounted() {
        
    },
    watch: {
        chartX: function () {
            this.createChart();
        }
    },
    methods: {
        // 创建图表
        createChart() {
            var myChart = this.$echarts.init(this.$el);

            var option = {
                tooltip: {
                    axisPointer: {
                        type: 'cross'
                    },
                    trigger: 'axis'
                },
                backgroundColor: "#2a2d2e",
                textStyle: {
                    color: "#a8a7a9"
                },
                grid: {
                    top: 10
                },
                xAxis: {
                    type: 'category',
                    data: this.chartX,
                    position: 'top',
                    show: false
                },
                yAxis: {
                    name: '回测',
                    type: 'value',
                    inverse: true,
                    axisLabel: {
                        formatter: "{value} %"
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#252425'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#5b5d5e'
                        }
                    }
                },
                series: {
                    type: 'line',
                    name: "回测",
                    data: this.chartY,
                    symbol: 'none',
                    lineStyle: {
                        width: 2,
                        color: '#db5634'
                    }
                }
            };

            myChart.setOption(option);
        }
    }
}
</script>

<style lang="scss" scoped>
.user-retreat-chart {
    width: 100%;
    height: 300px;
}
</style>
